"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adminAccountUpdate = adminAccountUpdate;
exports.adminAdd = adminAdd;
exports.adminDel = adminDel;
exports.adminInfo = adminInfo;
exports.adminList = adminList;
exports.adminPasswordUpdate = adminPasswordUpdate;
exports.adminUpdate = adminUpdate;
exports.editPassWordApi = editPassWordApi;
exports.sensitiveListApi = sensitiveListApi;
exports.updateIsSmsApi = updateIsSmsApi;
exports.updateReceiveSmsApi = updateReceiveSmsApi;
exports.updateStatusApi = updateStatusApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function adminDel(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/merchant/admin/delete',
    method: 'GET',
    params: data
  });
}
function adminInfo(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/merchant/admin/info',
    method: 'GET',
    params: data
  });
}
function adminList(params) {
  return (0, _request.default)({
    url: '/admin/merchant/admin/list',
    method: 'GET',
    params: params
  });
}
function adminAdd(pram) {
  var data = {
    account: pram.account,
    level: pram.level,
    pwd: pram.pwd,
    realName: pram.realName,
    roles: pram.roles.join(','),
    status: pram.status,
    phone: pram.phone
  };
  return (0, _request.default)({
    url: '/admin/merchant/admin/save',
    method: 'POST',
    data: data
  });
}
function adminUpdate(pram) {
  var data = {
    account: pram.account,
    phone: pram.phone,
    pwd: pram.pwd,
    realName: pram.realName,
    id: pram.id,
    roles: pram.roles,
    status: pram.status
  };
  return (0, _request.default)({
    url: '/admin/merchant/admin/update',
    method: 'POST',
    data: data
  });
}

/**
 * 修改状态
 * @param pram
 */
function updateStatusApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/admin/updateStatus",
    method: 'get',
    params: params
  });
}

/**
 * 修改后台管理员是否接收状态
 * @param pram
 */
function updateIsSmsApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/admin/update/isSms",
    method: 'get',
    params: params
  });
}

/**
 * 敏感操作日志分页列表
 * @param data
 */
function sensitiveListApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/log/sensitive/list",
    method: 'get',
    params: params
  });
}

/**
 * 修改登录用户信息
 * @param data
 */
function adminAccountUpdate(pram) {
  var data = {
    realName: pram.realName
  };
  return (0, _request.default)({
    url: '/admin/merchant/login/admin/update',
    method: 'POST',
    data: data
  });
}

/**
 * 修改登录用户密码
 * @param data
 */
function adminPasswordUpdate(pram) {
  var data = {
    confirmPassword: pram.confirmPassword,
    password: pram.password,
    oldPassword: pram.oldPassword
  };
  return (0, _request.default)({
    url: '/admin/merchant/login/admin/update/password',
    method: 'POST',
    data: data
  });
}

/**
 * 修改管理员密码
 * @param data
 */
function editPassWordApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/admin/update/password',
    method: 'POST',
    data: data
  });
}

/**
 * 商户后台管理员短信开关
 * @param pram
 */
function updateReceiveSmsApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/admin/update/receive/sms/".concat(id),
    method: 'post'
  });
}